import React, {useEffect, useState} from "react";
import enterpriseObjectClassFactory from "../../eoec/EnterpriseObjectClassFactory";
import EnterpriseObject from "../../eoec/eo/EnterpriseObject";
import EnterpriseComponent from "../../eoec/ec/EnterpriseComponent";
import EventBus from "../../util/EventBus";
import {Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField, Typography} from "@mui/material";
import css_buttons from "../Common/css/CCButton.module.scss";
import {DeleteForever, Moving} from "@mui/icons-material";
import CCButton from "../Common/CCButton";
import {makeEnterpriseComponent, updateObject} from "../../util/utility";
import {Blue3} from "../../theme/styles";
import * as validators from "../../util/Validators";


export default function ProjectPlanMilestoneRelocate(props: any) {
    const [projectPlanPhaseMilestoneEnterpriseComponent] = useState(makeEnterpriseComponent("ProjectPlanPhaseMilestone"));
    const [backgroundOperation, setBackgroundOperation] = useState<boolean>(false);
    const [controls, setControls] = useState<any>({"Phase": {"value": ""}});

    function enterpriseComponentUpdateStartedListener(ec: EnterpriseComponent) {
        setBackgroundOperation(true)
    }

    function enterpriseComponentUpdateCompletedListener(ec: EnterpriseComponent) {
        EventBus.components.emit("project-plan-phase-milestone-relocate-save");
    }

    useEffect(() => {
        projectPlanPhaseMilestoneEnterpriseComponent.addUpdateStartedListener(enterpriseComponentUpdateStartedListener);
        projectPlanPhaseMilestoneEnterpriseComponent.addUpdateCompletedListener(enterpriseComponentUpdateCompletedListener);

        projectPlanPhaseMilestoneEnterpriseComponent.newQuery();
        projectPlanPhaseMilestoneEnterpriseComponent.setAttributeValue("USID", props.projectPlanPhaseMilestone["USID"]);
        projectPlanPhaseMilestoneEnterpriseComponent.setIDOCRequest("v1.ProjectPlanPhaseMilestone-001");
        projectPlanPhaseMilestoneEnterpriseComponent.setIDOCResponse("v1.ProjectPlanPhaseMilestone-001");
        projectPlanPhaseMilestoneEnterpriseComponent.executeQuery(1, 5);

        return () => {
            projectPlanPhaseMilestoneEnterpriseComponent.removeUpdateStartedListener(enterpriseComponentUpdateStartedListener);
            projectPlanPhaseMilestoneEnterpriseComponent.removeUpdateCompletedListener(enterpriseComponentUpdateCompletedListener);
        }

    }, [projectPlanPhaseMilestoneEnterpriseComponent, props.projectPlanPhaseMilestone]);

    function phaseChangeHandler(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const updatedFormElement = updateObject(controls["Phase"], {
            value: event.target.value,
            touched: true,
            valid: true,
            helperText: null,
            invitationInProgress: false,
            userExistsInClinic: false,
            userExistsInProvider: false,
            userDoesNotExist: null,
            mainEmailVerifiedState: null,
            invitationSaved: false,
        });
        const updatedForm = updateObject(controls, {
            "Phase": updatedFormElement,
        });

        projectPlanPhaseMilestoneEnterpriseComponent.setAttributeValue("ProjectPlanPhaseUSID", event.target.value);
        setControls(updatedForm);
    }

    function onCancelHandler() {
        EventBus.components.emit("project-plan-phase-milestone-relocate-cancel");
    }

    function moveHandler() {
        projectPlanPhaseMilestoneEnterpriseComponent.executeUpdate();
    }

    function planDeleteView() {
        let buttonHandler = null;
        let objectDetailContent = null;

        let firstButtonHandlerContent = (
            <CCButton
                className={css_buttons.redStandardButton}
                onClick={onCancelHandler}>
                Cancel
            </CCButton>
        );

        let secondButtonHandlerContent = (
            <CCButton
                className={css_buttons.blueStandardButton}
                animate={backgroundOperation}
                onClick={() => moveHandler()}>
                Relocate
            </CCButton>
        )

        buttonHandler = (
            <DialogActions style={{marginBottom: "10px", width: "96%"}}>
                {firstButtonHandlerContent}
                {secondButtonHandlerContent}
            </DialogActions>
        );

        let phases = structuredClone(props.projectPlanBuffer.get("ProjectPlanPhases"));
        let index = phases.findIndex((x: any) => x["Name"] === props.projectPlanPhaseMilestone["ProjectPlanPhaseName"])
        phases.splice(index, 1);

        return (
            <>
                <Dialog open={true} scroll="body">
                    <DialogTitle>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                            <Typography style={{fontSize: "20px", fontWeight: 500, color: "#000000"}}>Relocate Milestone:&nbsp;&nbsp;</Typography>
                            <Typography style={{fontSize: "20px", fontWeight: 500, color: "#A8A9AF"}}>{props.projectPlanPhaseMilestone["Name"]}</Typography>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <div style={{display: "flex", flexDirection: "column"}}>
                            <div style={{display: "flex", flexDirection: "row", margin: "20px 20px 20px 0"}}>
                              <TextField
                                    select={true}
                                    fullWidth={true}
                                    value={controls["Phase"].value}
                                    onChange={(event) => phaseChangeHandler(event)}

                               >
                                    {phases.map((option: any) => (
                                        <MenuItem key={option.USID} value={option.USID}>
                                            {option.Name}
                                        </MenuItem>
                                    ))}

                                </TextField>
                            </div>
                        </div>
                        {objectDetailContent}
                    </DialogContent>
                    {buttonHandler}
                </Dialog>
            </>
        );
    }

    return (
        <>
            {planDeleteView()}
        </>
    )
}
